import { useSelector } from 'react-redux';
import { selectFilteredPoints } from '../filters/advancedFiltersSelectors';
import { useClientPagination } from '../helpers/hooks';
import { InfiniteScrollObserver } from '../helpers/InfiniteScrollObserver';
import { useEffect } from 'react';
import { BooleanStatus } from '../helpers/BooleanStatus';
// import { ArrowDownIcon, ArrowRightIcon, ArrowUpIcon } from '@iconicicons/react';

/**
 *
 * @typedef {{
 *  onClick: (point: import('../services/edgeApi').Point) => void;
 * }} PointListProps
 */

/**
 *
 * @type {React.FC<PointListProps>}
 */
export const PointsList = ({ onClick }) => {
  const points = useSelector(selectFilteredPoints);

  const {
    slice: paginatedPoints,
    exhausted,
    getNext,
    reset,
  } = useClientPagination(points, 30);

  useEffect(() => reset, [points]);

  return (
    <>
      {paginatedPoints.map((point) => (
        <div key={point.id} role="button" onClick={() => onClick?.(point)}>
          <div>
            <b>#{point.id}</b> {point.name} ({point.loc_id})
          </div>
          <div className="d-flex gap-3">
            <span>Type: {point.loc_type_ind}</span>
            <span>Direction: {point.dir_flo}</span>
            <span>
              {/* <ArrowDownIcon /> */}
              Receipt Zone: {point.receipt_zone_name}
            </span>
            <span>
              {/* <ArrowUpIcon /> */}
              Delivery Zone: {point.delivery_zone_name}
            </span>
          </div>
          <div className="d-flex gap-3 mt-3">
            <span>{point.tsp_name}</span>
          </div>
          <div className="text-end d-flex justify-content-end gap-3 mt-2">
            <BooleanStatus
              value={point.node}
              trueText="Mapped"
              falseText="Not Mapped"
            />
            {/* <BooleanStatus
              value={point.capacity_components?.length > 0}
              trueText="Has Flows"
              falseText="No Flows"
            />
            <BooleanStatus
              value={point.flow_activity}
              trueText="Flow Activity"
              falseText="No Flow Activity"
            />
            <BooleanStatus
              value={point.notice_components?.length > 0}
              trueText="Has Notices"
              falseText="No Notices"
            />
            <BooleanStatus
              value={point.notice_activity}
              trueText="Notice Activity"
              falseText="No Notice Activity"
            /> */}
          </div>
          <hr />
        </div>
      ))}
      {exhausted === false && <InfiniteScrollObserver onScrollIn={getNext} />}
    </>
  );
};
